import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { routing, appRoutingProviders } from './discovery.routing';
import { CommonModule } from '@angular/common';
import { DiscoveryComponent } from './discovery.component';
import { PipesModule } from '../../../pipes/pipes.module';
import { ClearFilterService } from '../../../services/clear-filter.service';
import { DebounceDirective } from './debounce.directive';
import { DropdownsModule } from '../../dropdowns/dropdowns.module';
import { DiscoveryRiskChartDirective } from './risk-chart/discovery-risk-chart.directive';
import { DiscoveryService } from './services/discovery-service';
import { SideFiltersComponent } from './side-filters/side-filters.component';
import { SideFilterItemComponent } from './side-filters/side-filter-item/side-filter-item.component';
import { DirectivesModule } from '../../../directives/directives.module';
import { AppListViewModule } from '../../app-list-view/app-list-view.module';
import { AppSummaryViewComponent } from './app-summary-view/app-summary-view.component';
import {DownloadCsvComponent} from './download-csv/download-csv.component';
import { NoFollowingComponent } from './no-following/no-following.component';

@NgModule({
  declarations: [
    DebounceDirective,
    DiscoveryComponent,
    DiscoveryRiskChartDirective,
    SideFiltersComponent,
    SideFilterItemComponent,
    AppSummaryViewComponent,
    DownloadCsvComponent,
    NoFollowingComponent
  ],
  imports: [
    AppListViewModule,
    DirectivesModule,
    PipesModule,
    DropdownsModule,
    CommonModule,
    FormsModule,
    routing
  ],
  providers: [
    ClearFilterService,
    appRoutingProviders,
    DiscoveryService
  ]
})
export class DiscoveryModule { }
